import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { UNDER_REVIEW } from '../helpers';

import Summary from './Summary';
import DisputeDetails from './DisputeDetails';
import EvidenceFormAdyen from './EvidenceForm.adyen';
import EvidenceFormStripe from './EvidenceForm.stripe';

import Loader from 'components/Loader';
import DashboardContainer from 'components/DashboardContainer';
import BreadCrumbs from 'components/BreadCrumbs';

import { disputeDetails as TEXT } from 'locales/en/dispute';
import { disputeByIdSelector, getDisputesById } from 'redux/slices/dispute';
import { refund } from 'redux/slices/transaction';
import DisputeCta from './DisputeCta';

const DisputeDetail = () => {
  const dispatch = useDispatch();
  const ref = useRef();
  const { id } = useParams();
  const { data: dispute, isLoading } = useSelector((state) =>
    disputeByIdSelector(state, id)
  );
  useEffect(() => {
    if (!isLoading) {
      dispatch(getDisputesById(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Loader />;

  const onClickSubmit = () => {
    if (ref?.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  const onClickRefund = () => {
    dispatch(refund({
      id: dispute.id,
      amount: dispute.amount,
      reason: dispute.reason
    }));
  }

  return !!dispute ? (
    <>
      <BreadCrumbs screen="dispute" />
      <DashboardContainer
        header={`${TEXT.header1} ${id}`}
        rightContent={(
          <DisputeCta
            dispute={dispute}
            onClickSubmitEvidence={onClickSubmit}
            hideSubmitEvidenceButton={dispute.defense_submitted && dispute.status === UNDER_REVIEW}
            onClickRefund={onClickRefund}
          />
        )}
      >
        <Summary dispute={dispute} />
        <DisputeDetails dispute={dispute} />
        {!dispute.defense_submitted &&
          dispute.transaction?.integration_type === 'adyen' && (
            <EvidenceFormAdyen dispute={dispute} ref={ref} />
          )}
        {!dispute.defense_submitted &&
          dispute.transaction?.integration_type === 'stripe' && (
            <EvidenceFormStripe dispute={dispute} ref={ref} />
          )}
      </DashboardContainer>
    </>
  ) : null;
};

export default DisputeDetail;
